import { useState, useEffect, startTransition } from 'react';

/**
 * Hook to determine if the component is mounted on the client side.
 * Prevents hydration mismatches in Next.js.
 */
const useIsClient = (): boolean => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    // avoid flicker across consumers on hydration
    startTransition(() => {
      setIsClient(true);
    });
  }, []);

  return isClient;
};

export default useIsClient;
